import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Hamburger = ({ handleLogout }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isLogoHovered, setIsLogoHovered] = useState(false);
  const [isHamburgerIconHovered, setIsHamburgerIconHovered] = useState(false);
  const [showExternalLinkModal, setShowExternalLinkModal] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  // Prevent body scroll when menu is open
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('menu-open');
    } else {
      document.body.classList.remove('menu-open');
    }

    // Cleanup on unmount
    return () => {
      document.body.classList.remove('menu-open');
    };
  }, [isOpen]);

  const handleMenuItemClick = () => {
    setIsOpen(false);
  };

  const handleLogoutClick = () => {
    setIsOpen(false);
    if (handleLogout) {
      handleLogout();
    }
  };

  const MenuContent = () => (
      <>
        {/* Mobile Navigation - Only show when menu is closed */}
        {!isOpen && (
          <>
            {/* Hamburger Button */}
            <div className={`hamburger m-0 p-0`}>
                <button 
                  className={`is-text`}
                  onClick={toggleMenu}
                  aria-label="Menu"
                  onMouseEnter={() => setIsHamburgerIconHovered(true)}
                  onMouseLeave={() => setIsHamburgerIconHovered(false)}
                >
                  ☰
                </button>
            </div>
            
            <div className='p-0 m-0 mainLogo'>
                <div className="m-0 p-0">
                    <Link 
                      to="/" 
                      className=''
                      onMouseEnter={() => setIsLogoHovered(true)}
                      onMouseLeave={() => setIsLogoHovered(false)}
                    >
                      Navigating Next
                    </Link>
                </div>
            </div>
          </>
        )}

        {/* Sliding Menu - Always rendered, controlled by CSS classes */}
        <div className={`menuContainer ${isOpen ? 'open' : ''}`}>
          <div className="menuContent">
              <div className='pr-3 m-0 is-flex is-align-items-center is-justify-content-end'>
                <div className='px-0 py-2'>
                  <button 
                    className='is-text'
                    onClick={toggleMenu}
                    aria-label="Close menu"
                  >
                    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M24.9999 24.9999L13 13M13 13L1 1M13 13L25 1M13 13L1 25" stroke="#8B1E1E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </button>
                </div>
              </div>
              <div className='pt-4 mx-4 m-0 is-flex is-flex-direction-column is-justify-content-center'>
                <div>
                  <p className={`p-1 m-1 menu-hamburger`}>
                    <Link to="/" onClick={handleMenuItemClick}>
                      Dashboard
                    </Link>
                  </p> 
                </div>
                <div>
                  <p className={`p-1 m-1 menu-hamburger`}>
                    <Link to="/products" onClick={handleMenuItemClick}>
                      Products
                    </Link>
                  </p> 
                </div>
                <div>
                  <p className={`p-1 m-1 menu-hamburger`}>
                    <Link to="/programs" onClick={handleMenuItemClick}>
                      Programs
                    </Link>
                  </p> 
                </div>
                <div>
                  <p className={`p-1 m-1 menu-hamburger`}>
                    <Link to="/contacts" onClick={handleMenuItemClick}>
                      Contacts
                    </Link>
                  </p> 
                </div>
                <div>
                  <p className={`p-1 m-1 menu-hamburger`}>
                    <Link to="/pods" onClick={handleMenuItemClick}>
                      Pods
                    </Link>
                  </p> 
                </div>
                <div>
                  <p className={`p-1 m-1 menu-hamburger`}>
                    <Link to="/deployments" onClick={handleMenuItemClick}>
                      Deployments
                    </Link>
                  </p> 
                </div>
                <div>
                  <p className={`p-1 m-1 menu-hamburger`}>
                    <Link to="/analytics" onClick={handleMenuItemClick}>
                      Analytics
                    </Link>
                  </p> 
                </div>
                <div>
                  <p className={`p-1 m-1 menu-hamburger`}>
                    <Link to="/profile" onClick={handleMenuItemClick}>
                      Profile
                    </Link>
                  </p> 
                </div>
                <div>
                  <p className={`p-1 m-1 menu-hamburger`}>
                    <Link to="/help" onClick={handleMenuItemClick}>
                      Help
                    </Link>
                  </p> 
                </div>
                <div>
                  <p className={`p-1 m-1 menu-hamburger`}>
                    <button 
                      onClick={handleLogoutClick} 
                      className="is-text"
                      style={{ border: 'none', background: 'none', textDecoration: 'none', color: 'inherit', cursor: 'pointer' }}
                    >
                      Logout
                    </button>
                  </p> 
                </div>
              </div>
          </div>
        </div>
      </>
    )
    return <MenuContent />;
};

export default Hamburger;